<script>
import FishIcon from './FishIcon.vue'

export default {
	name: 'HistoryFishComposition',
	components: { FishIcon },
	props: {
		fishes: {
			type: Array,
			default: () => [],
		},
		total: {
			type: Number,
			default: 0,
		},
		unit: {
			type: String,
			default: 'кг',
		},
		refNikad: {
			type: String,
			default: '',
		},
		recordId: {
			type: [String, Number],
			default: '',
		},
	},
	methods: {
		fishSize(fish) {
			const n = Number(fish.size || fish.available_volume || 0)
			return isFinite(n) ? n : 0
		},
		fishName(fish) {
			return fish.fish_name || fish.title || fish?.fish?.title || '-'
		},
		percent(fish) {
			if (!this.total) return 0
			const p = (this.fishSize(fish) / this.total) * 100
			return Math.max(0, Math.min(100, Math.round(p)))
		},
	},
}
</script>

<template>
	<div class="composition">
		<div class="composition__title">{{ $t('virtual_warehouse.history.composition') }}</div>

		<div v-for="(fish, index) in fishes" :key="index" class="composition__row">
			<div class="composition__head">
				<span class="composition__fish">
					<span class="composition__fish-icon">
						<fish-icon />
					</span>
					{{ fishName(fish) }}
				</span>
				<span class="composition__weight">{{ fishSize(fish) }} {{ unit }}</span>
			</div>
			<div class="composition__bar">
				<div class="composition__bar-fill" :style="{ width: percent(fish) + '%' }"></div>
			</div>
		</div>

		<div v-if="refNikad || recordId" class="composition__footer">
			<span v-if="refNikad" class="composition__meta">
				{{ $t('virtual_warehouse.history.ref_nikad') }}
				<strong>{{ refNikad }}</strong>
			</span>
			<span v-if="recordId" class="composition__meta">
				ID <strong>#{{ recordId }}</strong>
			</span>
		</div>
	</div>
</template>

<style scoped>
.composition {
	margin-top: 0;
	padding-top: 0;
}

.composition__title {
	font-size: 14px;
	font-weight: 600;
	color: #2b3a55;
	padding-bottom: 10px;
	border-bottom: 1px solid #eef2f8;
}

.composition__row {
	margin-bottom: 15px;
	margin-top: 15px;
}

.composition__head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;
}

.composition__fish {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	font-weight: 600;
	color: #2b3a55;
}

.composition__fish-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	color: #157fee;
}
.composition__fish-icon svg {
	width: 20px;
	height: 20px;
}

.composition__weight {
	font-size: 16px;
	font-weight: 600;
	color: #82819f;
	margin-right: 34px;
}

.composition__bar {
	height: 7px;
	border-radius: 999px;
	background: #e6eef8;
	overflow: hidden;
}

.composition__bar-fill {
	height: 100%;
	border-radius: 999px;
	background: #157fee;
	transition: width 0.3s ease;
}

.composition__footer {
	display: flex;
	flex-wrap: wrap;
	gap: 22px;
	margin-top: 15px;
	padding-top: 10px;
	border-top: 1px solid #eef2f8;
	font-size: 13px;
	color: #7787a0;
}

.composition__meta strong {
	color: #2b3a55;
	font-weight: 600;
}
</style>
